import React, { useEffect, useState } from 'react';
import { Modal } from '@hover/blueprint';
import DownloadAppModalMobile from './DownloadAppModalMobile';
import DownloadAppModalContentDesktop from './DownloadAppModalContentDesktop';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const DownloadAppModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 834);
    const checkIfMobile = () => setIsMobile(window.innerWidth < 834);

    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={isMobile ? 'large' : 'medium'}
    >
      <DownloadAppModalContentDesktop />
      <DownloadAppModalMobile />
    </Modal>
  );
};

export default DownloadAppModal;
